<style scoped>
.lista-blanca {
  padding: 20px;
  margin: 20px;
  background-color: white;
  border-radius: 10px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  margin-bottom: 15px;
  font-weight: 600;
  border-bottom: 1px solid;
  font-size: 20px;
  color: #333;
}

.content {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-top: 20px;
}

/* Mejoras para el selector de usuario */
.user-selector-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f4 100%);
  border: 1px solid #e0e0e0;
}

.user-selector-card .v-card-title {
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
  border-bottom: 1px solid #e0e0e0;
}

.user-info-badge {
  background: #e8f5e8;
  border: 1px solid #c8e6c9;
  border-radius: 16px;
  padding: 8px 12px;
}

.user-info-badge.warning {
  background: #fff3e0;
  border: 1px solid #ffcc02;
}
</style>

<template>
  <div class="usuario-mantenedor">
    <div
      style="
        padding: 20px;
        margin: 20px;
        background-color: white;
        border-radius: 10px;
      "
    >
      <h2>Gestión de Permisos de Usuario</h2>

      <!-- Sección de selección de usuario -->
      <v-card class="mb-6 user-selector-card" outlined>
        <v-card-title class="d-flex align-center text-grey-darken-2">
          <v-icon class="mr-2">mdi-account-search</v-icon>
          Selección de Usuario
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" md="8">
              <v-combobox
                v-model="usuarioSel"
                :items="lstUsuarios"
                variant="outlined"
                autocomplete="off"
                hide-details
                @update:modelValue="selectUsuario"
                clearable
                item-title="rutDisplayName"
                item-value="rut"
                label="Buscar y seleccionar usuario"
                prepend-inner-icon="mdi-account"
                placeholder="Escriba para buscar un usuario..."
                density="comfortable"
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props">
                    <v-list-item-subtitle>{{
                      item.raw.email || "Sin email"
                    }}</v-list-item-subtitle>
                  </v-list-item>
                </template>

                <template v-slot:selection="{ item }">
                  <span>{{ item.raw.rutDisplayName }}</span>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Sección de configuración de permisos -->
      <v-card class="mb-6" outlined>
        <v-card-title class="bg-grey-lighten-4">
          <v-icon class="mr-2">mdi-shield-check</v-icon>
          Configuración de Permisos
        </v-card-title>

        <v-card-text class="pt-6">
          <v-row>
            <!-- Tipos de Solicitud -->
            <v-col cols="12" md="6">
              <v-card class="mb-4" outlined>
                <v-card-subtitle class="font-weight-bold text-grey-darken-2">
                  <v-icon class="mr-1" size="18">mdi-file-document</v-icon>
                  Tipos de Solicitud
                </v-card-subtitle>
                <v-card-text class="pt-2">
                  <v-autocomplete
                    v-model="tiposSel"
                    :items="lstTipoSolicitud"
                    color="blue-grey-lighten-2"
                    item-title="nombre"
                    item-value="id"
                    label="Seleccionar tipos"
                    chips
                    closable-chips
                    multiple
                    density="compact"
                    variant="outlined"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        :text="item.raw.nombre"
                        size="small"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                        v-bind="props"
                        :title="item.raw.nombre"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Empresas -->
            <v-col cols="12" md="6">
              <v-card class="mb-4" outlined>
                <v-card-subtitle class="font-weight-bold text-grey-darken-2">
                  <v-icon class="mr-1" size="18">mdi-office-building</v-icon>
                  Empresas
                </v-card-subtitle>
                <v-card-text class="pt-2">
                  <v-autocomplete
                    v-model="empresasSel"
                    :items="lstListaEmpresas"
                    color="blue-grey-lighten-2"
                    item-title="name"
                    item-value="id"
                    label="Seleccionar empresas"
                    chips
                    closable-chips
                    multiple
                    density="compact"
                    variant="outlined"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        :text="item.raw.name"
                        size="small"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                        v-bind="props"
                        :title="item.raw.name"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Departamentos -->
            <v-col cols="12" md="6">
              <v-card class="mb-4" outlined>
                <v-card-subtitle class="font-weight-bold text-grey-darken-2">
                  <v-icon class="mr-1" size="18">mdi-account-group</v-icon>
                  Departamentos
                </v-card-subtitle>
                <v-card-text class="pt-2">
                  <v-autocomplete
                    v-model="departamentosSel"
                    :items="lstListaDepartamentos"
                    color="blue-grey-lighten-2"
                    item-title="codeDisplayName"
                    item-value="code"
                    label="Seleccionar departamentos"
                    chips
                    closable-chips
                    multiple
                    density="compact"
                    variant="outlined"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        :text="item.raw.codeDisplayName"
                        size="small"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                        v-bind="props"
                        :title="item.raw.codeDisplayName"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Proyectos -->
            <v-col cols="12" md="6">
              <v-card class="mb-4" outlined>
                <v-card-subtitle class="font-weight-bold text-grey-darken-2">
                  <v-icon class="mr-1" size="18">mdi-briefcase</v-icon>
                  Proyectos
                </v-card-subtitle>
                <v-card-text class="pt-2">
                  <v-autocomplete
                    v-model="proyectosSel"
                    :items="lstListaProyectos"
                    color="blue-grey-lighten-2"
                    item-title="prefijoTipo"
                    item-value="prefijo"
                    label="Seleccionar proyectos"
                    chips
                    closable-chips
                    multiple
                    density="compact"
                    variant="outlined"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        :text="item.raw.prefijoTipo"
                        size="small"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                        v-bind="props"
                        :title="item.raw.prefijoTipo"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Botón de guardar -->
      <div class="text-center" v-if="usuarioSel">
        <v-btn
          v-on:click="guardarListaBlanca()"
          :loading="saving"
          :disabled="!usuarioSel || saving"
          color="primary"
          size="large"
          prepend-icon="mdi-content-save"
          class="mt-2 mb-4"
        >
          {{ saving ? "Guardando..." : "Guardar Configuración" }}
        </v-btn>
      </div>
    </div>
  </div>

  <v-overlay
    :model-value="isLoading"
    class="align-center justify-center"
    persistent
  >
    <v-progress-circular
      color="#a61a2f"
      size="50"
      :width="5"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import swal from "sweetalert2";
import { translateBcError } from "@/utils/errorTranslator";
import { TIPOS, normalizeTipoSolicitud } from "@/utils/tipoSolicitudHelpers";

import type { Usuario } from "../types/usuario";

import useUsuario from "../composables/useUsuario";
import useListaBlanca from "../composables/useListaBlanca";

import type { TipoSolicitud } from "../types/tipoSolicitud";
import type { ListaBlanca } from "../types/listaBlanca";
import type { ListaEmpresa } from "../types/listaEmpresa";
import type { ListaDimension } from "../types/listaDimension";
import type { ProyectoNomenclatura } from "../types/ProyectoNomenclatura";

// Composables
const { getUsuarios, lstUsuarios } = useUsuario();
// const { getCompanies, lstEmpresas } = useEmpresa();
const {
  getListaBlanca,
  postListaBlanca,
  postListaBlancaMasivo,
  deleteListaBlanca,
  listaEmpresas,
  listaDepartamentos,
  listaProyectos,
} = useListaBlanca();

// Store
const store = useStore(key);

// Reactive variables
const loading = ref(false);
const saving = ref(false);
const usuarioSel = ref<Usuario | null>(null);
const tiposSel = ref<string[]>([]);
const empresasSel = ref<string[]>([]);
const departamentosSel = ref<string[]>([]);
const proyectosSel = ref<string[]>([]);
const isLoading = ref(false);

const lstTipoSolicitud = ref<TipoSolicitud[]>([]);
const lstListaBlanca = ref<ProyectoNomenclatura[]>([]);
const lstListaEmpresas = ref<ListaEmpresa[]>([]);
const lstListaDepartamentos = ref<ListaDimension[]>([]);
const lstListaProyectos = ref<ProyectoNomenclatura[]>([]);

// Lifecycle
onMounted(async () => {
  store.state.titulo = "Permisos de Usuario";
  // Inicialización del componente
  await getUsuarios();
});

async function selectUsuario() {
  try {
    isLoading.value = true;

    lstTipoSolicitud.value = [
      { id: TIPOS.COMPRA, nombre: TIPOS.COMPRA },
      { id: TIPOS.RETIRO_BODEGA, nombre: TIPOS.RETIRO_BODEGA },
      { id: TIPOS.RENDICION, nombre: TIPOS.RENDICION },
      { id: TIPOS.INGRESO_RESPEL, nombre: TIPOS.INGRESO_RESPEL },
      { id: TIPOS.RETIRO_RESPEL, nombre: TIPOS.RETIRO_RESPEL },
    ];

    lstListaEmpresas.value = await listaEmpresas();
    lstListaDepartamentos.value = await listaDepartamentos();
    lstListaProyectos.value = await listaProyectos();

    let listas = await getListaBlanca(usuarioSel.value?.rut || "", null);

    // Limpiar selecciones previas
    tiposSel.value = [];
    empresasSel.value = [];
    departamentosSel.value = [];
    proyectosSel.value = [];

    // Marcar los elementos ya existentes en la lista blanca
    listas.forEach((item) => {
      switch (item.tipo) {
        case "TipoSolicitud":
          const rawNombre = item.nombre?.trim() ?? "";
          const normalized = normalizeTipoSolicitud(rawNombre);
          const tipo = lstTipoSolicitud.value.find(
            (t) => t.nombre.trim() === normalized
          );
          if (tipo && !tiposSel.value.includes(tipo.id)) {
            tiposSel.value.push(tipo.id);
          }
          break;
        case "Empresa":
          const empresa = lstListaEmpresas.value.find(
            (e) => e.name.trim() === item.nombre.trim()
          );
          if (empresa && !empresasSel.value.includes(empresa.id)) {
            empresasSel.value.push(empresa.id);
          }
          break;
        case "Departamento":
          const depto = lstListaDepartamentos.value.find(
            (d) => d.displayName.trim() === item.nombre.trim()
          );
          if (depto && !departamentosSel.value.includes(depto.code)) {
            departamentosSel.value.push(depto.code);
          }
          break;
        case "Proyecto":
          const proyecto = lstListaProyectos.value.find(
            (p) => p.tipoProyecto.trim() === item.nombre.trim()
          );

          if (proyecto && !proyectosSel.value.includes(proyecto.prefijo)) {
            proyectosSel.value.push(proyecto.prefijo);
          }
          break;
      }
    });
  } catch (error) {
    console.error("Error al cargar datos del usuario:", error);
    alert("Error al cargar datos del usuario: " + error);
  } finally {
    isLoading.value = false;
  }
}

async function guardarListaBlanca() {
  if (!usuarioSel.value) {
    swal.fire({
      icon: "warning",
      title: "Atención",
      text: "Debe seleccionar un usuario",
      confirmButtonText: "Entendido",
      confirmButtonColor: "#a61a2f",
    });
    return;
  }

  // Verificar que al menos un campo esté seleccionado
  if (
    tiposSel.value.length === 0 &&
    empresasSel.value.length === 0 &&
    departamentosSel.value.length === 0 &&
    proyectosSel.value.length === 0
  ) {
    alert(
      "Debe seleccionar al menos un elemento para agregar a la lista blanca"
    );
    return;
  }

  saving.value = true;

  try {
    const registrosAInsertar: Omit<ListaBlanca, "id">[] = [];
    const usuario = usuarioSel.value.rut || "";

    // Agregar tipos de solicitud
    tiposSel.value.forEach((tipo) => {
      registrosAInsertar.push({
        tipo: "TipoSolicitud",
        nombre: tipo,
        usuario: usuario,
      });
    });

    // Agregar empresas
    empresasSel.value.forEach((empresa) => {
      const empresaObj = lstListaEmpresas.value.find((e) => e.id === empresa);
      if (empresaObj) {
        registrosAInsertar.push({
          tipo: "Empresa",
          nombre: empresaObj.name,
          usuario: usuario,
        });
      }
    });

    // Agregar departamentos
    departamentosSel.value.forEach((departamento) => {
      const deptoObj = lstListaDepartamentos.value.find(
        (d) => d.code === departamento
      );
      if (deptoObj) {
        registrosAInsertar.push({
          tipo: "Departamento",
          nombre: deptoObj.displayName,
          usuario: usuario,
        });
      }
    });

    // Agregar proyectos
    proyectosSel.value.forEach((proyecto) => {
      const proyectoObj = lstListaProyectos.value.find(
        (p) => p.prefijo === proyecto
      );
      if (proyectoObj) {
        registrosAInsertar.push({
          tipo: "Proyecto",
          nombre: proyectoObj.tipoProyecto,
          usuario: usuario,
        });
      }
    });

    // Insertar todos los registros usando el método masivo
    if (registrosAInsertar.length > 0) {
      const success = await postListaBlancaMasivo(
        registrosAInsertar,
        usuario
      );

      if (success) {
        swal.fire({
          icon: "success",
          title: "Éxito",
          text: `Se actualizo existosamente`,
          showConfirmButton: false,
          timer: 2000,
        });
        // Limpiar los campos después del guardado exitoso
        limpiarFormulario();
      } else {
        swal.fire({
          icon: "error",
          title: "Error",
          text: "Error al guardar los registros en la lista blanca",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#a61a2f",
        });
      }
    }
  } catch (error: any) {
    console.error("Error al guardar lista blanca:", error);
    const t = translateBcError(error.message); // { message, correlationId, key }

    swal.fire({
      icon: "error",
      title: "Error",
      text: "Error al guardar: " + t.message,
      confirmButtonText: "Entendido",
      confirmButtonColor: "#a61a2f",
    });
  } finally {
    saving.value = false;
  }
}

function limpiarFormulario() {
  tiposSel.value = [];
  empresasSel.value = [];
  departamentosSel.value = [];
  proyectosSel.value = [];

  usuarioSel.value = null;
}
</script>
